import React, { useEffect } from "react";
import HeroSection from "../../components/UserSideComponents/HomePage/HeroSection";
import CarRentalSection from "../../components/UserSideComponents/HomePage/Carrentalsection";
import TrendingCategories from "../../components/UserSideComponents/HomePage/TrendingCategories";
import DestinationsSection from "../../components/UserSideComponents/HomePage/DestinationsSection";
import CarRentalHeroV2 from "../../components/UserSideComponents/HomePage/CarRentalHeroV2";
import PopularCarsV2 from "../../components/UserSideComponents/HomePage/PopularCarsV2";
import StatsAndTestimonials from "../../components/UserSideComponents/HomePage/StatsAndTestimonials";
import FAQAndPricing from "../../components/UserSideComponents/HomePage/FAQAndPricing";
import CarFrames from "../../components/UserSideComponents/HomePage/CarFrames";
const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="overflow-hidden">
      <HeroSection />
      <CarRentalSection />
      <TrendingCategories />
      <DestinationsSection />
      <CarRentalHeroV2 />
      <PopularCarsV2 />
      <StatsAndTestimonials />
      <FAQAndPricing />
      <CarFrames />
    </div>
  );
};

export default Home;
